import { IMySalesExpenseInitialState } from "../../../types/sales/salesExpenseInterface";
import { SalesExpenseActionTypes, SalesExpenseActions } from "../../actionTypes/sales/saleExpenseActionTypes";


const initialState: IMySalesExpenseInitialState = {
  myExpenseList: [],
  myExpenseData: {
    id: 0,
    bill_img: "",
    expense_value: 0,
    expense_type: "",
    employee_id: 0,
    request_closed_by: null,
    sales_activity_id: null,
    created_by: null,
    branch_id: null,
    hub_id: null,
    status: "",
    reason: "",
    description: "",
    createdAt: null,
    updatedAt: null,
    branch_data: {
      id: 0,
      branch_code: "",
      branch_name: "",
    },
    hub_data: {
      id: null,
      hub_name: "",
      hub_code: "",
    },
    employee_data: {
      id: 0,
      name: "",
      code: "",
    },
    sales_activity_data: {
      title: "",
    }
  },
  myExpenseListPageCount: 0,
};

export default function mySalesExpenseReducer(state = initialState, action: SalesExpenseActionTypes): IMySalesExpenseInitialState {
  switch (action.type) {

    case SalesExpenseActions.SET_MY_SALES_EXPENSE_LIST:
      return {
        ...state,
        myExpenseList: action.payload    
      };

    case SalesExpenseActions.SET_MY_SALES_EXPENSE_LIST_PAGE_COUNT:
      return {
        ...state,
        myExpenseListPageCount: action.payload
      };

    case SalesExpenseActions.SET_MY_SALES_EXPENSE_DATA_BY_ID:
      return {
        ...state,
        myExpenseData: action.payload
      }

    default:
      return state;
  }
}
